import { deepmerge } from '@mui/utils';
import common from './common';

const edlenTraining = deepmerge(common, {
    palette: {
        primary: {
            main: '#80477d', // '#1E73BA',
            light: '#9d6e9b', // '#2499E2',
            dark: '#5c2d59', //'#195497',
        },
    },
    header: {
        background: '#80477d', //'#7F0077',
        text: '#FFF',
        button: {
            background: '#80477d', //'#66005F',
      text: '#FFF',
        },
        logo: 'edlenWhite',
    },
});

export default edlenTraining;
